import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["inert"]
const _hoisted_2 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_TopicTile = _resolveComponent("TopicTile")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_TrackerDelete = _resolveComponent("TrackerDelete")

  return (_openBlock(), _createElementBlock("div", {
    class: "edit-topic",
    inert: $data.saving
  }, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : ($data.topic)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($props.head)
              ? (_openBlock(), _createBlock(_component_TopicTile, {
                  key: 0,
                  class: "header",
                  name: $data.topic.name
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_ScrollBar, {
              class: "settings",
              "bar-x-offset": "-2rem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TrackerSegment, {
                  title: "TRACKER SENSITIVITY",
                  tooltip: "signal_sensitivity"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TrackerButtongroup, {
                      modelValue: $data.topic.tracker_focus,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.topic.tracker_focus) = $event)),
                      options: $data.SENSITIVITY
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_TrackerSegment, {
                  title: "EMAIL ALERTS",
                  tooltip: "email_notifications"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TrackerButtongroup, {
                      modelValue: $data.topic.tracker_alerts,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.topic.tracker_alerts) = $event)),
                      options: $data.ALERTS
                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_TrackerSegment, {
                  title: "WHAT SHOULD WE WATCH FOR?",
                  tooltip: "topic_customize_tracking"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TrackerTextarea, {
                      modelValue: $data.topic.focus_on,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.topic.focus_on) = $event)),
                      title: "Focus tracking on:",
                      placeholder: "e.g. product launches and partnerships"
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_Divider, { m: "0 -2.4rem 2.4rem" }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Button, {
                class: "delete-button",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.$refs.delete.open($data.topic)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    icon: "trash-2",
                    size: "1.5rem",
                    stroke: "var(--error-500)"
                  }),
                  _cache[4] || (_cache[4] = _createTextVNode(" Delete Tracker "))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Button, {
                primary: "",
                disabled: !$data.topic.changed,
                onClick: $options.onSave
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Save")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _createVNode(_component_TrackerDelete, { ref: "delete" }, null, 512 /* NEED_PATCH */)
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Could not load this topic.", -1 /* HOISTED */)),
            _createVNode(_component_Button, { onClick: $options.init }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Try again")
              ])),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
          ], 64 /* STABLE_FRAGMENT */))
  ], 8 /* PROPS */, _hoisted_1))
}